export const GRETA_AI_CHAT_CHATS_PAGE_SIZE = 50

export const GRETA_AI_CHAT_CHATS_PARAMS = {
  archived: false,
  page: 1,
  page_size: GRETA_AI_CHAT_CHATS_PAGE_SIZE,
}

export const GRETA_AI_CHAT_CHATS_INITIAL_PAGING = { hasMore: false, page: 1 }

export const GRETA_AI_CHAT_CHATS_POLL_MS = 15000
